module.exports = __webpack_public_path__ + "img/acreditacion_5.be3e7d34.png";